import { ProfilePage } from './profile.component';
import { connect } from 'react-redux';
import { userUpdate } from './../../api/user/userAction';

const mapDispatchToProps = {
    userUpdate
};

const mapStateToProps = state => ({
    loggedUser: state.userPage.loggedUser
});

export const ProfileContainer = connect(mapStateToProps, mapDispatchToProps)(ProfilePage);